module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.5b1e54a7.jpg";